export default function SectionHeader({ title }) {
  return (
    <div style={styles.header}>
      <span style={styles.chevron}>⌄</span>
      <span style={styles.title}>{title}</span>
    </div>
  );
}

const styles = {
  header: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    marginBottom: 18
  },

  chevron: {
    fontSize: 18,
    color: "#9AA3B2"
  },

  title: {
    fontSize: 20,
    fontWeight: 600,
    color: "#535557fd"
  }
};